import { MessageBar, MessageBarType } from '@fluentui/react';
import { BasicTable } from '@h2oai/ui-kit';

import type { S3Error, S3Object } from '../../../drive/types';
import type { FileProgressEntry } from '../../../drive/useFileProgress';
import { createFileTableColumns } from '../helpers';
import type { SortableField, SortDirection } from '../types/sorting';

interface FileTableProps {
  objects: S3Object[];
  isLoading: boolean;
  error: S3Error | null;
  onDeleteFile: (key: string) => void;
  isWriter: boolean;
  currentPath?: string;
  onDirectoryClick?: (directoryPath: string) => void;
  onCopyFile?: (key: string) => void;
  onMoveFile?: (key: string) => void;
  onRenameFile?: (item: S3Object) => void;
  onDownloadFile?: (key: string) => void;
  sortField?: SortableField | null;
  sortDirection?: SortDirection;
  onSort?: (field: SortableField) => void;
  onCopyLinkItem?: (item: S3Object) => void;
  onShareAccessItem?: (item: S3Object) => void;
  fileProgressMap?: Map<string, FileProgressEntry>;
  canDownload?: boolean;
}

export const FileTable = (params: FileTableProps) => {
  const {
    objects,
    isLoading,
    error,
    isWriter,
    currentPath,
    onDeleteFile,
    onDirectoryClick,
    onCopyFile,
    onMoveFile,
    onRenameFile,
    onDownloadFile,
    sortField,
    sortDirection,
    onSort,
    onCopyLinkItem,
    onShareAccessItem,
    fileProgressMap,
    canDownload,
  } = params;
  const columns = createFileTableColumns(
    onDeleteFile,
    isWriter,
    currentPath,
    onDirectoryClick,
    onCopyFile,
    onMoveFile,
    onRenameFile,
    onDownloadFile,
    sortField,
    sortDirection,
    onSort,
    onCopyLinkItem,
    onShareAccessItem,
    fileProgressMap,
    canDownload
  );

  if (error) {
    return <MessageBar messageBarType={MessageBarType.error}>Failed to load files: {error.message}</MessageBar>;
  }

  if (objects.length === 0 && !isLoading) return <p>No files found</p>;

  return (
    <BasicTable
      columns={columns}
      items={objects}
      styles={{
        root: {
          borderRadius: 4,
          overflow: 'hidden',
          '.h2o-ListCell-content': { width: '100%' },
        },
        rows: {
          verticalAlign: 'middle',
        },
      }}
    />
  );
};
